import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { AttractionsFirestoreResponse } from '../../types';
import { fetchDocumentById } from '../utils';

const COLLECTION_PATH = 'attractions';

export const useGetAttractionDocumentFromFirestore = (
  documentId: string | null | undefined,
  options?: UseQueryOptions<AttractionsFirestoreResponse | null, FirebaseError>,
): UseQueryResult<AttractionsFirestoreResponse | null, FirebaseError> => useQuery<
AttractionsFirestoreResponse | null, FirebaseError>({
  queryKey: [`attraction-${documentId}`] as const,
  queryFn: async (): Promise<AttractionsFirestoreResponse | null> => {
    const data = await fetchDocumentById<AttractionsFirestoreResponse>(COLLECTION_PATH, documentId);
    return data
      ? {
        id: data.id,
        title: data.title,
        address: data.address,
        city: data.city,
        createdAt: data.createdAt,
        thumbnail: data.thumbnail,
        cover_photo: data.cover_photo,
        type: data.type,
        recomended: data.recomended,
        brand_icon: data.brand_icon,
        gallery: data.gallery,
        web_url: data.web_url,
        isBuyTicketUrl: data.isBuyTicketUrl,
        discount: data.discount,
        description: data.description,
        localization: data.localization,
        addressData: data.addressData,
        translationStatus: data.translationStatus,
        showDiscount: data?.showDiscount,
        createdBy: data?.createdBy,
        price: data?.price,
        currency: data?.currency,
        duration: data?.duration,
        email: data?.email,
        status: data?.status,
        phone: data.phone,
        reportEmail: data.reportEmail,
        endDate: data.endDate,
        languages: data.languages,
      }
      : null;
  },
  enabled: !!documentId,
  retry: 0,
  ...options,
});
